import OrderResultsModal from "./OrderResultsModal";

export default OrderResultsModal;
